// extra spotler functionality

const $ = require('jquery');

let scrollPrevented = false; 

// prevent scroll to footer newsletter form
preventNewsletterScroll();

function preventNewsletterScroll() {

	// don't execute function if scroll is already prevented
	if (scrollPrevented) {
		return;
	}

	// define newsletter form variables
	let $newsletter = $('.newsletter'),
	$form = $newsletter.find('.mpForm'),
	$formInput = $newsletter.find('.mpFormField input'),
	inputsBlurred = 0;

	// check if form exists
	if ($form.length) {

		$formInput.each(function() {

			// add sublabel as placeholder if set in Spotler
			sublabel = $(this).find('.sublabel').text();
			$(this).attr('placeholder', sublabel);	

			// remove focus from input
			$(this).blur();

			// count nr of inputs that are blurred
			if (!$(this).is(':focus')) {
				inputsBlurred++;
			}

			// check if all inputs in form are blurred
			if (inputsBlurred === $formInput.length) {
				scrollPrevented = true;
			}
		});
	}

	if (scrollPrevented) {
		// show newsletter form if all inputs have their focus removed
		$newsletter.show();

		return;
	}

	// if focus is not yet removed
	preventNewsletterScroll();
}

// replace default field required text or aterisk with icon of choice in spotler
$('.mandatorySign').each( function() {
	$(this).html('<i class="fas fa-lock"></i>');
});

